import validator from 'validator';
import DOMPurify from 'dompurify';

export const sanitize = (value) => {
    return DOMPurify.sanitize(value || '').trim();
};

export const validateFormFields = (fields, context = 'default') => {
    const errors = {};

    // First Name
    if (!fields.first_name || !/^[a-zA-Z\s\-']+$/.test(fields.first_name)) {
        errors.first_name = 'First name should only contain letters';
    }

    // Last Name
    if (!fields.last_name || !/^[a-zA-Z\s\-']+$/.test(fields.last_name)) {
        errors.last_name = 'Last name should only contain letters';
    }

    // Email
    if (!fields.email || !validator.isEmail(fields.email)) {
        errors.email = 'Enter a valid email address';
    }

    // Department (only if present)
    if (fields.department !== undefined) {
        if (!fields.department || fields.department.trim().length < 2 || !/^[a-zA-Z0-9\s&\/.\-]+$/.test(fields.department)) {
            errors.department = 'Department must be at least 2 characters and contain valid characters';
        }
    }

    // Phone
    if (!fields.phone || !validator.isMobilePhone(fields.phone, 'any', { strictMode: false })) {
        errors.phone = 'Enter a valid phone number';
    }

    // Timezone
    if (!fields.timezone || !['EST', 'CST', 'PST'].includes(fields.timezone)) {
        errors.timezone = 'Please select a valid timezone';
    }

    // Student-specific validations
    if (context === 'student') {
        if (!fields.guardian_email || !validator.isEmail(fields.guardian_email)) {
            errors.guardian_email = 'Enter a valid guardian email';
        }

        if (!fields.grade_id) {
            errors.grade_id = 'Select your grade';
        }

        if (!fields.academic_year) {
            errors.academic_year = 'Select your academic year';
        }

        if (fields.require_facilitator === 'yes') {
            if (!fields.facilitator_email || !validator.isEmail(fields.facilitator_email)) {
                errors.facilitator_email = 'Enter a valid facilitator email';
            }
        }

        if (!fields.privacyAccepted) {
            errors.privacyAccepted = 'You must accept the privacy notice';
        }
    }

    return errors;
};
